export default "__VITE_ASSET__yCET5aVR__"